export const setItemToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getItemFromLocalStorage = (key) => {
  const item = localStorage.getItem(key);

  try {
    const parsedItem = JSON.parse(item);
    return parsedItem;
  } catch (e) {
    return item;
  }
};

export const removeItemFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

// SessionStorage functions for tab-isolated data
export const setItemToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getItemFromSessionStorage = (key) => {
  const item = sessionStorage.getItem(key);

  try {
    const parsedItem = JSON.parse(item);
    return parsedItem;
  } catch (e) {
    return item;
  }
};

export const removeItemFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

